import React from "react";
import { convertirLetraMayus } from "../helpers/convertirLetraMayus";

export const CustomInputSelect = (props) => {

    const { label, options, error, onChange, value, disabled, placeholder, type, all } = props;

    return (
        <div style={{ display: 'flex', flexFlow: 'column noWrap', gap: 5, marginBottom: 15 }}>
            <label style={{ fontWeight: 600, fontSize: 14 }} htmlFor="select">{ label }</label>
            <select 
                style={
                    error ? { borderRadius: 4, border: '1px solid #d32f2f', padding: 9 }
                          : { borderRadius: 4, border: '1px solid #bdbdbd', padding: 9 }
                } 
                id='select' 
                onChange={ onChange } 
                value={ value }
                disabled={ disabled }
            >
                <option value=''>{ placeholder }</option>
                { options?.map((o, i) => <option key={ String(i) } value={ type?.includes('id') ? (o?._id || o?.uid) : (o?.name || o?.nombre) }>{ convertirLetraMayus(o?.name) }</option>)}
                { all && <option value='all'>{ convertirLetraMayus(all) }</option> }
            </select>
            <span 
                style={
                    error ? { fontSize: 12, color: '#d32f2f', marginLeft: 5 }
                          : { fontSize: 12, color: 'rgba(0,0,0,.6)', marginLeft: 5 }
                }
            >
                { error && error?.message }
            </span>
        </div>
    )
};

CustomInputSelect.defaultProps = {
    label: 'Label',
    options: [],
    error: null,
    onChange: () => false,
    value: '',
    disabled: false,
    placeholder: 'Seleccione una opción',
    type: 'id',
    all: ''
}